import Alpine from 'alpinejs';

import 'lazysizes';
import { LuminousGallery } from 'luminous-lightbox';
// Import Swiper and modules
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

// Import Swiper styles
// We're importing this in site.css instead, because of tailwind and layer order
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/thumbs';

window.NIBOSTONE = window.NIBOSTONE || {};

// Alpine
window.Alpine = Alpine;
Alpine.start();


NIBOSTONE.init = function () {
	console.log('# Init');

	NIBOSTONE.lightbox();
	NIBOSTONE.formSamples();
	NIBOSTONE.formQuote();
	NIBOSTONE.initReviewsSlider();
};

window.niboStone = function () {
	return {
		siteSegment: window.siteSegment ?? 'consumers',
		showBusinessNav: false,
		sidebarOpen: false,
		showMobileSearch: false,
		atTop: true,
		showTop: false,
		isContactOpen: false,
		init() {

		},
	};
};

/**
 * Lightbox Gallery
 */
NIBOSTONE.lightbox = function () {
	var galleryOpts = {
		// Whether pressing the arrow keys should move to the next/previous slide.
		arrowNavigation: true,
	};
	var luminousOptions = {
		injectBaseStyles: false,
		caption: (trigger) => trigger.querySelector('img').getAttribute('data-caption'),
	};
	new LuminousGallery(document.querySelectorAll('.materialZoomLink'), galleryOpts, luminousOptions);
};

/**
 * Sample Form Functions
 */
NIBOSTONE.formSamples = function () {
	var $form = document.querySelector('.js-form-sampleform');

	if ($form) {
		var $submit = $form.querySelector('button[type="submit"]');
		var $chosenSamplesInput = document.querySelector('.js-form-chosenSamples');

		$submit.addEventListener('click', function () {
			var $sampleChoices = document.querySelectorAll('.js-form-sample-choice:checked');
			var chosenSamplesArray = [];

			// To get all the selected checkbox values
			// Set value of textarea to selected checkboxes
			$sampleChoices.forEach(function (sample, index) {
				console.log(sample.value);
				console.log(index);
				chosenSamplesArray.push(sample.value);
			});

			$chosenSamplesInput.value = chosenSamplesArray.join('\n');
		});
	}
};

/**
 * Quote Form Functions
 */
NIBOSTONE.formQuote = function () {
	var $form = document.querySelector('.js-form-quoteform');

	if ($form) {
		var $submit = $form.querySelector('button[type="submit"]');
		var $chosenProductsInput = document.querySelector('.js-form-chosenProducts');

		$submit.addEventListener('click', function () {
			var $productChoices = document.querySelectorAll('.js-form-product-choice:checked');
			var chosenProductsArray = [];

			$productChoices.forEach(function (sample, index) {
				console.log(sample.value);
				console.log(index);
				chosenProductsArray.push(sample.value);
			});

			$chosenProductsInput.value = chosenProductsArray.join('\n');
		});
	}
};

/**
 * Snipcart Functions
 */
NIBOSTONE.snipCart = function () {
	const $snip = document.getElementById('snipcart');
	const $main = document.getElementById('main');


	document.addEventListener('snipcart.ready', () => {
		// Snipcart.api.session.setLanguage('nl', {
		// 	cart_summary: {
		// 		taxes: 'BTW',
		// 	},
		// });

		// toggleCheckoutButton();

		// Redirect to custom thank you page
		Snipcart.events.on('cart.confirmed', (cartConfirmResponse) => {
			var url = '/bedankt-voor-uw-bestelling';
			window.location.href = url;
		});

		// Snipcart.events.on("snipcart.initialized", () => {
		//     // Milliseconds, total quantity
		//     setTimeout(
		//         toggleCheckoutButton
		//     , 100);
		// });

		// Snipcart.events.on('theme.routechanged', (routesChange) => {
		//     console.log(routesChange);
		//     if (routesChange.from === "/" && routesChange.to !== "/") {
		//         setTimeout(
		//             toggleCheckoutButton()
		//         , 100);
		//     }
		// })


	});
};

/**
 * Init all the things
 */
window.addEventListener('load', (event) => {
	// var acForm = document.querySelector('form._form');
	// var submitButton = acForm.querySelector('._submit');
	// var isValid = false;
	// submitButton.addEventListener('click', function(evt) {
	// 	var to = setTimeout( function(){
	// 		var errors = acForm.querySelector('._has_error');
	// 		if (errors) {
	// 			var isValid = false;
	// 			console.error("Has errors")
	// 		} else {
	// 			var isValid = true;
	// 			console.info("no errors")
	// 		}
	// 		if (isValid) {
	// 			// submitButton.setAttribute('disabled', true);
	// 			submitButton.innerText += "...";
	// 		}
	// 		console.log("AC submit");
	// 	}, 200);
	// });

	// Initialize any catalog sliders on the page
	NIBOSTONE.initCatalogSlider();
});

// DOM ready
// document.addEventListener('DOMContentLoaded', function(){
// });

/**
 * Reviews Slider
 */
NIBOSTONE.initReviewsSlider = function() {
	const reviewsSlider = document.querySelectorAll('.reviews-slider .swiper');
	if (!reviewsSlider) return;

	reviewsSlider.forEach(slider => {
		new Swiper(slider, {
			modules: [Navigation, Pagination],
			slidesPerView: "auto",
			spaceBetween: 20,
			loop: true,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next-testimonials',
                prevEl: '.swiper-button-prev-testimonials',
            },
            breakpoints: {
			    // Mobile first
				// 320: {
				// 	slidesPerView: 1,
				// 	centeredSlides: false,
				// },
				// 768: {
				// 	slidesPerView: 2.15,
				// 	centeredSlides: false,
				// },
				// 1024: {
				// 	slidesPerView: 3.15,
				// 	centeredSlides: false,
				// }
			}
		});
	});
};

/**
 * Catalog Slider
 */
NIBOSTONE.initCatalogSlider = function() {
	const catalogMainSlider = document.querySelector('.catalog-main-slider');
	if (!catalogMainSlider) return;

	const thumbsSlider = new Swiper('.catalog-thumbs-slider', {
		spaceBetween: 10,
		slidesPerView: 'auto',
		watchSlidesProgress: true,
	});

	new Swiper(catalogMainSlider, {
		modules: [Navigation, Thumbs],
		spaceBetween: 10,
		navigation: {
			nextEl: '.swiper-button-next-catalog',
			prevEl: '.swiper-button-prev-catalog',
		},
		thumbs: {
			swiper: thumbsSlider
		},
		grabCursor: true
	});
};
